import React, { useEffect, useState } from "react";
import "./header.css";
import { useLocation } from "react-router-dom";
import { FaRegBell } from "react-icons/fa";
import { Breadcrumb, Row, Col } from "react-bootstrap";
import { BsLayoutSidebar } from "react-icons/bs";
import { useAuth } from "../../Context/AuthContext";

const Header = () => {
  const location = useLocation();
  // eslint-disable-next-line
  const [pathname, setPathname] = useState(location.pathname);

  const { toggleNotificationHandler } = useAuth();

  useEffect(() => {
    setPathname(location.pathname);
  }, [location.pathname]);

  return (
    <React.Fragment>
      <Row>
        <div className="header_top_section">
          <Col>
            <div className="d-flex gap-3">
              <div>
                <BsLayoutSidebar className="mt-1 me-3" size={18} />
                {/* <FaRegStar className='mt-1' size={18} /> */}
              </div>
              <Breadcrumb>
                <Breadcrumb.Item href="/" className="text_section">
                  Dashboard
                </Breadcrumb.Item>
                {/* <Breadcrumb.Item active> {pathname}</Breadcrumb.Item> */}
              </Breadcrumb>
            </div>
          </Col>

          <Col>
            <div className="search_section">
              {/* <CiSearch className='search_icon' /> */}
              {/* <input type="text" placeholder='search' /> */}
              <div className="d-flex gap-3 mt-1">
                {/* <BsBrightnessHigh size={18} /> */}
                {/* <AiOutlineHistory size={18} /> */}
                <FaRegBell
                  onClick={toggleNotificationHandler}
                  size={18}
                />
                {/* <BsLayoutSidebar size={18} /> */}
              </div>
            </div>
          </Col>
        </div>
      </Row>
    </React.Fragment>
  );
};

export default Header;
